import { connect } from 'react-redux';

import ObjectView from './ObjectViews';

import View from '@scene/views/object-view';
import { setDimensionsLabels, setMode } from '@reducers/actions';

import Scene from '@scene';
import { hide3DDimensions, show3DDimensions } from '@reducers/options/actions';
import { PerspectiveCameraTypes, setPerspectiveCameraType } from '@reducers/camera/actions';

const mapState = state => ({
  nextMode: state.main.mode === View.mode.MODE_3D ? View.mode.MODE_2D : View.mode.MODE_3D,
  currentMode: state.main.mode,
  loadUnit: state.main.units.load,
  momentUnit: state.main.units.moment,
  isGettingSnapshots: state.webServices.calculate.isGettingSnapshots || false,
  displayDimensions: state.options.object.dimensions.display || false,
  displayLabels: state.options.object.dimensions.showLabels || false,
  appStatus: state.main.status,
  appType: state.main.appType,
  perspectiveCameraType: state.camera.perspectiveCameraType || PerspectiveCameraTypes.zoom_out
});

const mapDispatch = dispatch => ({
  setMode: (currentMode, mode) => {
    if (currentMode !== View.mode.MODE_2D_EDITOR)
      dispatch(setMode(mode));
  },
  resetCamera: () => Scene.resetCamera(),
  show3DDimensions: () => dispatch(show3DDimensions()),
  hide3DDimensions: () => dispatch(hide3DDimensions()),
  setDimensionsLabels: (value) => { dispatch(setDimensionsLabels(value)); },
  setPerspectiveCameraType: (currentType) => { 
    if (currentType === PerspectiveCameraTypes.zoom_out)
      dispatch(setPerspectiveCameraType(PerspectiveCameraTypes.focus_base_plate)); 
    else 
      dispatch(setPerspectiveCameraType(PerspectiveCameraTypes.zoom_out));
  }
});

export default connect(mapState, mapDispatch)(ObjectView);



// WEBPACK FOOTER //
// ./src/components/ObjectViews/index.js